import React, { useEffect, useState } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';

const UploadBar:React.FC<IProps> = (props) => {

  return (
    <S.Root style ={{
      width: `${props.width}px`,
      height: `${props.height}px`,
      borderRadius: `${props.height/2}px`
    }} >
      <S.ProgressBar style ={{
        width: `${props.width*props.progress/100}px`,
        borderRadius: `${props.height/2}px`
      }} />
    </S.Root>
  );
}

export default UploadBar;